import React from 'react';
import { DropletIcon, TrashIcon, ZapIcon } from 'lucide-react';
interface ControlToolbarProps {
  onFillPBS: () => void;
  onFillPathogen: () => void;
  onEmptyToWaste: () => void;
  onPerformDetection: () => void;
  chambersReady: boolean;
}
export const ControlToolbar: React.FC<ControlToolbarProps> = ({
  onFillPBS,
  onFillPathogen,
  onEmptyToWaste,
  onPerformDetection,
  chambersReady
}) => {
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-2 mt-2" data-id="element-44">
      <div className="flex flex-wrap justify-around gap-1.5" data-id="element-45">
        <ControlButton label="Fill PBS" icon={<DropletIcon className="text-blue-500" size={16} data-id="element-47" />} onClick={onFillPBS} color="blue" data-id="element-46" />
        <ControlButton label="Fill Pathogen" icon={<div className="text-orange-500" size={16} data-id="element-49" />} onClick={onFillPathogen} color="orange" warning data-id="element-48" />
        <ControlButton label="Empty to Waste" icon={<TrashIcon className="text-gray-500" size={16} data-id="element-51" />} onClick={onEmptyToWaste} color="gray" disabled={!chambersReady} data-id="element-50" />
        <ControlButton label="Perform Detection" icon={<ZapIcon className="text-purple-500" size={16} data-id="element-53" />} onClick={onPerformDetection} color="purple" disabled={!chambersReady} data-id="element-52" />
      </div>
    </div>;
};
interface ControlButtonProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  color: 'blue' | 'orange' | 'gray' | 'purple';
  disabled?: boolean;
  warning?: boolean;
}
const ControlButton: React.FC<ControlButtonProps> = ({
  label,
  icon,
  onClick,
  color,
  disabled = false,
  warning = false
}) => {
  const getColorClasses = () => {
    const baseClasses = 'flex flex-col items-center justify-center rounded-lg px-4 py-2 transition-all duration-200 focus:outline-none';
    if (disabled) {
      return `${baseClasses} bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700`;
    }
    switch (color) {
      case 'blue':
        return `${baseClasses} bg-blue-100 hover:bg-blue-200 text-blue-800 dark:bg-blue-900 dark:hover:bg-blue-800 dark:text-blue-200`;
      case 'orange':
        return `${baseClasses} ${warning ? 'bg-red-100 hover:bg-red-200 text-red-800 dark:bg-red-900 dark:hover:bg-red-800 dark:text-red-200' : 'bg-orange-100 hover:bg-orange-200 text-orange-800 dark:bg-orange-900 dark:hover:bg-orange-800 dark:text-orange-200'}`;
      case 'gray':
        return `${baseClasses} bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200`;
      case 'purple':
        return `${baseClasses} bg-purple-100 hover:bg-purple-200 text-purple-800 dark:bg-purple-900 dark:hover:bg-purple-800 dark:text-purple-200`;
      default:
        return baseClasses;
    }
  };
  return <button className={`${getColorClasses()} ${warning ? 'relative' : ''} w-full sm:w-auto`} onClick={onClick} disabled={disabled} aria-label={label} data-id="element-54">
      {warning && <span className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-red-500 rounded-full animate-pulse" data-id="element-55"></span>}
      <div className="mb-1" data-id="element-56">{icon}</div>
      <span className="font-medium text-xs" data-id="element-57">{label}</span>
    </button>;
};